import { Component, EventEmitter, inject, OnDestroy, Output, signal } from '@angular/core';
import { RecommendedCreatorItemComponent } from '../recommended-creator-item/recommended-creator-item.component';
import { SlickOnboard } from '../../service/slick-onboard/slick-onboard.service';
import { MagicSearchService } from '../../../creators/service/magic-search/magic-search.service';
import { CollaboratorService } from '../../../../services/collaborator/collaborator.service';
import { CreateBriefApplicationDto } from '../../../../common/general-types/brief-application.dto';
import { FirebaseService } from '../../../../common/firebase/firebase.service';
import { PricingModelV2Dto } from '../../../../common/general-types/pricing.dto';
import { take } from 'rxjs';
import { BriefApplicationService } from '../../../../services/brief-application/brief-application.service';

@Component({
  selector: 'v2-recommended-creators',
  standalone: true,
  imports: [RecommendedCreatorItemComponent],
  templateUrl: './recommended-creators.html',
  styleUrl: './recommended-creators.css',
})
export class RecommendedCreators implements OnDestroy {

  @Output() stepComplete = new EventEmitter<boolean>();

  isInvitingCreators = signal<boolean>(false);
  
  // Typewriter chat simulation
  chatMessages = signal<{ text: string; displayedText: string; isComplete: boolean }[]>([]);
  currentMessageIndex = signal<number>(0);
  currentCharIndex = signal<number>(0);
  private typewriterInterval: any;
  private messageDelay: any;

  /** Services  */
  private slickOnboardService = inject(SlickOnboard);
  public magicSearchService = inject(MagicSearchService);
  public collaboratorsService = inject(CollaboratorService);
  private firebaseService = inject(FirebaseService);
  private briefApplicationService = inject(BriefApplicationService);
  /** Services - END */


  creatorsSelected() {
    console.log('creatorsSelected() -> ', this.collaboratorsService.selectedCreators().length);
    console.log('Focussed Brief -> ', this.slickOnboardService.newlyCreatedBrief());

    if (this.slickOnboardService.newlyCreatedBrief() && this.slickOnboardService.newlyCreatedBrief()?.id && this.collaboratorsService.selectedCreators().length > 0) {
      console.log('Creators Selected -> ', this.collaboratorsService.selectedCreators().length);
      console.log('Focussed Brief -> ', this.slickOnboardService.newlyCreatedBrief());

      this.inviteCreators();
      this.simulateInviteCreatorsChat();
    } else {
      console.log('No Creators Selected or Focussed Brief');
      this.stepComplete.emit(true);

    }
  }

  simulateInviteCreatorsChat() {
    // Stop any existing chat simulation
    this.stopChatSimulation();

    // Initialize chat messages with progress updates
    const messages = [
      "Composing an encouraging message for each creator...",
      "Sending invitations to creators...",
      "Sending push notifications...",
      "Sending emails...",
      "Wrapping up brief publication and creator invites..."
    ];

    // Initialize chat messages state
    this.chatMessages.set(messages.map(text => ({ text, displayedText: '', isComplete: false })));
    this.currentMessageIndex.set(0);
    this.currentCharIndex.set(0);

    // Start typing the first message
    this.typeNextMessage();
  }

  typeNextMessage() {
    const messages = this.chatMessages();
    const currentIndex = this.currentMessageIndex();

    if (currentIndex >= messages.length) {
      return;
    }

    const currentMessage = messages[currentIndex];
    this.currentCharIndex.set(0);

    this.typewriterInterval = setInterval(() => {
      const charIndex = this.currentCharIndex();
      const message = messages[currentIndex];

      if (charIndex < message.text.length) {
        const displayedText = message.text.substring(0, charIndex + 1);
        const updatedMessages = [...messages];
        updatedMessages[currentIndex] = { ...message, displayedText };
        this.chatMessages.set(updatedMessages);
        this.currentCharIndex.set(charIndex + 1);
      } else {
        // Message complete
        const updatedMessages = [...messages];
        updatedMessages[currentIndex] = { ...message, displayedText: message.text, isComplete: true };
        this.chatMessages.set(updatedMessages);
        clearInterval(this.typewriterInterval);

        // Move to next message after a delay
        if (currentIndex < messages.length - 1) {
          this.messageDelay = setTimeout(() => {
            this.currentMessageIndex.set(currentIndex + 1);
            this.typeNextMessage();
          }, 800);
        }
      }
    }, 30); // Typing speed
  }

  stopChatSimulation() {
    if (this.typewriterInterval) {
      clearInterval(this.typewriterInterval);
      this.typewriterInterval = null;
    }
    if (this.messageDelay) {
      clearTimeout(this.messageDelay);
      this.messageDelay = null;
    }
  }


  inviteCreators() {
    console.log('inviteCreators()');
    this.isInvitingCreators.set(true);
    const applications: CreateBriefApplicationDto[] = [];

    for (const creator of this.collaboratorsService.selectedCreators()) {
      applications.push({
        briefId: this.slickOnboardService.newlyCreatedBrief()?.id!,
        creatorUserId: creator.blazeFirebaseUid,
        firstName: creator.firstName,
        lastName: creator.lastName,
        applicationStatus: 1,
        hiredPricing: this.slickOnboardService.newlyCreatedBrief()?.basePricingModel as PricingModelV2Dto,
        createdBy: this.firebaseService.userId!
      });
    }

    console.log('applications: ', applications);

    this.briefApplicationService.createBulkBriefApplications(applications).pipe(take(1)).subscribe((response: any) => {
      console.log('creators invited: ', response);

      this.isInvitingCreators.set(false);
      this.stepComplete.emit(true);

    }, err => {
      console.error('error inviting creators: ', err);
      this.isInvitingCreators.set(false);
    });
  }

  ngOnDestroy() {
    this.stopChatSimulation();
  }
}
